export default {
  es: {
    BANNER_BUTTON: 'Ver detalles',
    COURSE_RECOMMENDATION: 'Cursos recomendados por la comunidad',
    COURSE_NEW: 'Cursos nuevos',
    COURSE_WATCH_MORE_2: 'Ver todos',
    COURSE_MEMBERSHIP_TITLE: 'Ten acceso total con Premium',
    COURSE_MEMBERSHIP_SUBTITLE:
      'Únete a nuestra comunidad Premium y accede a +1000 cursos y +9 carreras.',
    COURSE_MEMBERSHIP_BUTTON: 'Me interesa',
    COURSE_CAREERS_TITLE:
      'Conviertete en <span className="{specialistClassnames}">especialista</span>',
    COURSE_CAREERS_WATCH_MORE: 'Explora más expecializaciones',
    COURSE_CERTIFICATIONS_TITLE: 'Certificate',
    COURSE_CERTIICATIONS_WATCH_MORE: 'Explora más certificaciones',
    SHOW_ALL_COURSES: 'Mostrar todos los cursos',
    ALL_COURSES: 'Todos los cursos',
    SEO_RECOMMENDED: 'Cursos recomendados por la comunidad',
    SEO_NEWS: 'Nuevos Cursos online',
    SEO_FREE: 'Cursos online gratis',
    SEO_DISCOUNT: 'Cursos en oferta',
    FILTER: 'Filtrar',
    SORT_BY: 'Ordenar',
    RESET_FILTERS: 'Limpiar',
    RETURN: 'Regresar',
    CLEAN_FILTERS: 'Limpiar Filtros',
    AD_TITLE1: '¡Aprovecha el ',
    AD_TITLE2: '% dto. en tu próxima compra!',
    AD_MIN_AMOUNT: 'Monto mínimo',
    AD_DESCRIPTION:
      'Tu descuento se aplicará en el momento de tu compra. Sólo aplica a cursos y certificaciones.',
    AD_BUTTON: 'Llévame al catálogo',
    BECOME_PREMIUM: 'Aprovecha',
    BECOME_PREMIUM_DESCRIPTION: 'Accede a todos estos cursos con rebajas',
    SIGNUP_BANNER_TITLE: '¡Accede gratis a estos cursos!',
    BANNER_FREE_TITLE: 'Prueba una nueva forma de aprender',
    BANNER_FREE_SUBTITLE:
      'Obtén una prueba gratis de la membresía Premium y descubre +1000 cursos y por todo 1 día.',
    BANNER_FREE_CTA: 'Prúebala gratis hoy',

    EXIT_POPUP_TITLE: '¡Espera! Tienes una prueba gratuita disponible',
    EXIT_POPUP_SUB_TITLE:
      'Aún tienes más cursos por descubrir con nuestra membresía, totalmente gratis por 24 horas.',
    EXIT_POPUP_CTA: 'Pruébalo ahora',
    POPUP_MARATHON_TITLE: '¡Te damos la bienvenida a la Maratón Crehana!',
    POPUP_MARATHON_CTA_LABEL: 'Empezar',
    BUY_NOW: 'Comprar ahora',
    GET_NOW: 'Adquirir ahora',
    BUY: 'Comprar',
    LANGUAGE: 'Idioma',
    BACK_TO_TOP: 'Volver arriba',
    VISUAL_REST_FREE_TITLE: 'Ten acceso total con Premium',
    VISUAL_REST_FREE_SUBTITLE:
      'Únete a nuestra comunidad Premium y accede a +1000 cursos en 16 categorías.',
    VISUAL_REST_BE_PREMIUM: 'Quiero ser Premium',
    VISUAL_REST_PREMIUM_TITLE: 'Prepara a tu equipo para los desafíos de hoy',
    START: 'Inicio',
    RESULTS_EMPTY_SUBTITLE:
      'Sin embargo, creemos que estos cursos podrían interesarte',
    CATALOG_IMPROVE_SKILLS: 'Mejora otras habilidades',
    CATALOG_COURSE_IN_TITLE: 'Cursos en',
    CATALOG_COURSE_IN_X_TITLE: 'Cursos en {{name}}',
    CATALOG_COURSE_OF_TITLE: 'Cursos de',
    CATALOG_COURSE_OF_X_TITLE: 'Cursos de {{name}}',
    CATALOG_NOT_RESULTS_FOR: 'No hemos encontrado resultados para {{name}}',
    CATALOG_STUDENTS: 'Estudiantes',
    CATALOG_CLEAN_FILTERS: 'Borrar filtros',
    CATALOG_APPLIED_FILTERS: 'Filtros aplicados',
    CATALOG_LINK_ONLINE_COURSES: 'Cursos online',
    CATALOG_LINK_NEW_COURSES: 'Cursos nuevos',
    CATALOG_LINK_OFFERT_COURSES: 'Cursos en oferta',
    CATALOG_LINK_FREE_COURSES: 'Cursos gratis',
    CATALOG_CATEGORIES: 'Categorías',
    CATALOG_SOFTWARE: 'Software',
    CATALOG_NIVEL: 'Niveles',
    CATALOG_SHOW_MORE: 'Mostrar más',
    CATALOG_SHOW_LESS: 'Ver menos',
    CATALOG_FILTER_RESULTS: 'Filtrar resultados',
    CATALOG_APPLY_FILTERS: 'Aplicar filtros',
    CATALOG_ORDER_BY: 'Ordenar por',
    CATALOG_PREMIUM_VISUAL_REST_MESSAGE:
      'Desarrolla al talento de tu organización con programas de skilling.',
    CATALOG_BE_PREMIUM: 'Hazte Premium',
    CATALOG_FILTER_DURATION: 'Duración',
    COURSE_TAG_FREE: 'Curso gratis',
    GIFT_TO_FRIEND_BTN: 'Regalar a un amigo',
    ALL_ACCESS_FREE_PERIOD_LABEL: 'Gratis por 48hrs',
    ALL_ACCESS_POPUP_TITLE: 'Aprovecha este All Access por 48hrs',
    ALL_ACCESS_POPUP_DESCRIPTION:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque dapibus, leo vitae accumsan sollicitudin',
    TOTAL_LABEL: 'Resultado',
    TOTAL_LABEL_2: 'Resultados',
    FREE_LABEL: 'Gratis',

    /**
     *  se usa tempralmente labels de organizar por:
     * hasta que backend haga las traducciones
     *  */
    Recomendados: 'Recomendados',
    Ofertas: 'Ofertas',
    Nuevos: 'Nuevos',
    'Cursos Gratis': 'Cursos Gratis',
    CATALOG_ACADEMIES_SECTION_TITLE:
      'Academias relacionadas con {{categoryName}}',
    SUBSCRIBE_FREE: '¡Inscríbete gratis!',

    PREVIEW_TRIAL_START_BUTTON: 'Probar curso gratis',
  },
};
